import React, { useEffect, useState } from 'react';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import Button from '../../../../components/elements/button';
import Icon from '../../../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import { StatusStaticCell, titleCell } from '../../../../components/elements/function';
import moment from 'moment';
import { showLocalDate } from '../../../../_common/functions';
import { PAGE_SIZE } from '../../../../_common/constant';
import toast from 'react-hot-toast';
import Pagination from '../../../../components/pagination';
import { Link } from 'react-router-dom';
import { URLS } from '../../../../_config';

interface Props {
    _ref: React.RefObject<HTMLDialogElement>;
    schedulerID?: any;
    onCloseCallback?: () => void;
}

const OpenWOlistModal: React.FC<Props> = ({ _ref, schedulerID, onCloseCallback }) => {
    const [rowData, setrowData] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const workOrderApi: any = useWorkOrderApi();
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);

    const columnDefs = [
        {
            headerName: 'Task No', field: 'workOrderCode', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (data: any) => {
                return (
                    <Link to={URLS.WORK_ORDER_DETAILS(data.data.workOrderID)} target='_blank' className='hover:text-primary font-semibold cursor-pointer'> {data.value}  </Link>
                )
            }
        },
        {
            headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', minWidth: 160, cellRenderer: (params: any) => {
                return (
                    <p className='hover:text-primary '>
                        {params.data.facilityName}
                    </p>
                )
            }, tooltipValueGetter: (params: any) => {
                return params.data.facilityName + (params.data.subFacilityName ? `, ${params.data.subFacilityName}` : '')
            }
        },
        {
            headerName: 'Start Date', field: 'startDate', headerClass: 'bg-[#f0f0f0]', width: 140, cellStyle: { textAlign: 'center' }, cellRenderer: (data: any) => {
                return (
                    <p className={''} title={(+data.data.woStatusID >= 4) ? ((data.data.originalStartDate ? moment.utc(data.data.originalStartDate).local().format(`MM/DD/YYYY hh:mm A`) : '--')) : (data.data.startDate ? moment.utc(data.data.startDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`)}>
                        {data.value ? showLocalDate(data.value) : `--`}
                    </p>
                )
            }
        },
        {
            headerName: 'End Date', field: 'endDate', headerClass: 'bg-[#f0f0f0]', width: 140, cellRenderer: (data: any) => {
                return (
                    <p className={``} title={+data.data.woStatusID >= 4 ? (data.data.originalEndDate ? moment.utc(data.data.originalEndDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`) : (data.data.endDate ? moment.utc(data.data.endDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`)}>{data.value ? showLocalDate(data.value) : `--`}</p>
                )
            }
        },
        { headerName: 'Priority', flex: 1, field: 'priorityName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
        { headerName: 'Status', field: 'woStatusName', headerClass: 'bg-[#f0f0f0]', width: 200, cellRenderer: StatusStaticCell },
        {
            headerName: 'Assignment Type', field: 'woAssignmentTypeName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (params: any) => {
                return (
                    <div className='text-ellipsis overflow-hidden' title={`${params.value}`}>{params.value || `--`}</div>
                )
            }
        },
    ];

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const GetWorkOrderList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            schedulerID: schedulerID,
            sortingBy: 'StartDate',
            sortingOrder: 'asc',
        };
        setrowData(null);
        workOrderApi.GetWorkOrderList(
            payload,
            (resp: any) => {
                setrowData(resp.workOrderList || []);
                setTotalRecords(resp.totalRecord);
            },
            (error: any) => {
                console.log('error =>', error);
                toast.error(error);
            }
        );
    };

    useEffect(() => {
        if (schedulerID) {
            GetWorkOrderList();
        }
    }, [schedulerID, currentPage]);

    const handleClose = () => {
        _ref?.current?.close();
        if (onCloseCallback && typeof onCloseCallback === 'function') {
            onCloseCallback();
        }
    };

    return (
        <dialog ref={_ref} className={_ref?.current?.open ? "modal" : "hidden"}>
            <div className="modal-box max-w-[90%] w-[75rem] p-4">
                <form>
                    <div className="flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2">
                        <p className="text-[1.063rem] text-[#755B51] font-semibold">
                            List of Task
                        </p>
                        <button type="button"
                            onClick={handleClose}
                            className="bg-primary text-white p-1 rounded-md"
                        >
                            <Icon name="close" size={1.25} />
                        </button>
                    </div>
                    <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                        <Pagination
                            perPage={PAGE_SIZE}
                            totalRecords={totalRecords}
                            onPageChange={setCurrentPage}
                            currentPage={currentPage}
                        />
                    </div>

                    <div className="max-h-[500px] overflow-auto overflow-x-auto">
                        <AgGridReact
                            columnDefs={columnDefs} // Pass columnDefs
                            rowData={rowData || []} // Pass rowData
                            pagination={false}
                            rowSelection="multiple"
                            onGridReady={onGridReady}
                            domLayout="autoHeight"
                            noRowsOverlayComponent={() => (
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-center text-gray-500">
                                        <div className="text-lg font-medium">No Data Found</div>
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                </form>
            </div>
            <form method="dialog" className="modal-backdrop" onClick={handleClose}></form>
        </dialog>
    );
}

export default OpenWOlistModal;